import request from '@/utils/request'
import API from './api'
//题目管理-图片订正


//题目管理-图片订正-任务列表
export function getImageCorrectionTaskListAPI(data) {
  return request({
    url: API.IMAGE_CORRECTION_TASK_LIST,
    method: 'post',
    data
  })
}

//题目管理-图片订正-筛选人员列表
export function getMemberListAPI(data) {
  return request({
    url: API.IMAGE_CORRECTION_MEMBER_LIST,
    method: 'post',
    data
  })
}


//题目管理-图片订正-分配人员
export function assignStaffAPI(assignType,postForm) {
  let url='',
  	  task_id=postForm.task_id
  let data={task_id,[assignType]:postForm[assignType]}
  
  switch (assignType){
  	case 'sign_user':
  		url=API.ASSIGN_SIGN_USER
  		break;
  	case 'sign_check_user':
  		url=API.ASSIGN_SIGN_CHECK_USER
  		break;
  	case 'icon_user':
  		url=API.ASSIGN_ICON_USER
  		break;
  	case 'icon_check_user':
  		url=API.ASSIGN_ICON_CHECK_USER
  		break;
  	case 'icon_and_check_user':
  		url=API.ASSIGN_ICON_AND_CHECK_USER
  		data={
  			task_id,
  			icon_user:postForm.icon_user,
  			icon_check_user:postForm.icon_check_user
  		}
  		break;
  	case 'check_user':
  		url=API.ASSIGN_CHECK_USER
  		break;
  	default:
  		break;
  }
 	
  return request({
    url,
    method: 'post',
    data
  })
}

// 任务进行到的位置
export function getTaskPositionAPI(data) {
  return request({
    url: API.CURRENT_QUESTION_PAGE,
    method: 'post',
    data
  })
}

// 插画
export function insertPictureAPI(data) {
  return request({
    url: API.INSERT_PICTURE,
    method: 'post',
    data
  })
}

// 修改插画
export function modifyPictureAPI(data) {
  return request({
    url: API.MODIFY_PICTURE,
    method: 'post',
    data
  })
}

// 插画审核通过
export function picturePassAPI(data) {
  return request({
    url: API.PICTURE_PASS,
    method: 'post',
    data
  });
}

// 插画返工
export function pictureReworkAPI(data) {
  return request({
    url: API.PUCTURE_REWORK,
    method: 'post',
    data
  });
}

// 标记修改
export function signModyfyAPI(data) {
  return request({
    url: API.SIGN_MODIFY,
    method: 'post',
    data
  });
}

// 标记返工
export function signReworkAPI(data) {
  return request({
    url: API.SIGN_REWORK,
    method: 'post',
    data
  });
}

// 标记通过
export function signPassAPI(data) {
  return request({
    url: API.SIGN_PASS,
    method: 'post',
    data
  });
}

// 标记题目
export function signTitleAPI(data) {
  return request({
    url: API.SIGN_TITLE,
    method: 'post',
    data
  });
}

// 题目详情
export function getTitleDetailAPI(data) {
  return request({
    url: API.TITLE_DETAIL,
    method: 'post',
    data
  });
}

//题目管理-图片订正-获取章节列表
export function getAllAssistListAPI() {
  return request({
    url: API.GET_NO_SUBJECT_ASSIST_LIST,
    method: 'post'
  })
}


//题目管理-图片订正-获取章节列表详情
export function getTreeListAPI(data) {
  return request({
    url: API.GET_TREE_LIST,
    method: 'post',
    data
  })
}


 //题目管理-图片订正-创建任务
export function  createImageCorrectionTaskAPI(data) {
  return request({
    url: API.CREATE_IMAGE_CORRECTION_TASK,
    method: 'post',
    data
  })
}


//题目管理-图片订正-修改任务状态：提交、返工、删除
export function  modifyTaskStatusAPI(stage_type,modifyType,data) {
 
  let url='',
  	 actionKey=`${stage_type}_${modifyType}`,
 	 urlMap={
	  	'signing_submit':API.SIGNING_SUBMIT,//标记中-提交
	  	'signing_delete':API.SIGNING_DELETE,//标记中-删除
	  	'sign_checking_submit':API.SIGN_CHECKING_SUBMIT,//标记审核中-提交
	  	'sign_checking_rework':API.SIGN_CHECKING_REWORK,//标记审核中-返工
	  	'sign_rework_submit':API.SIGN_REWORK_SUBMIT,//标记返工-提交
	  	'icon_ing_submit':API.ICONING_SUBMIT,//插画中-提交
	  	'icon_checking_submit':API.CHECKING_SUBMIT,//插画审核中-提交
	  	'icon_checking_rework':API.CHECKING_REWORK,//插画审核中-返工
	  	'icon_rework_submit':API.ICON_REWORK_SUBMIT,//插画返工-提交
	  	'checking_submit':API.CHECKING_SUBMIT,//题目审核中-提交
	  	'checking_rework':API.CHECKING_REWORK,//题目审核中-返工
	  }

  return request({
    url: urlMap[actionKey],
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/API/image-correction.js